module.exports = __webpack_public_path__ + "static/media/nisaiP.1889a530.pdf";